<template>
    <div class="footer-content">
        <div class="content">
            <div>
                <div class="title">
                    <img src="../assets/logo-footer.webp" alt="logo" />
                    ANUPARP BUSINESS COMPANY LIMITED
                </div>
                <div class="address">
                    <img src="../assets/footer-icon1.webp" alt="" class="icon">
                    hello@anupapbusiness.com
                </div>
                <div class="address">
                    <img src="../assets/footer-icon2.webp" alt="" class="icon">
                    446 หมู่ที่ 1 ตำบลกุยบุรี อำเภอกุยบุรี จ.ประจวบคีรีขันธ์ 77150
                </div>
                <div class="address">
                    <img src="../assets/footer-icon3.webp" alt="" class="icon">
                    โทร: +66 0969272367
                </div>
                <div class="address">
                    หมายเลขบริษัท：0775562000877
                </div>
                <div class="address">
                    <a href="https://www.anupapbusiness.com/privacy_FlexibleLoan.html" target="_blank"
                        rel="noopener noreferrer">นโยบายความเป็นส่วนตัว</a>
                </div>
            </div>
            <div class="btns">
                <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)">
                    {{ btn.name }}
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2026 Hak Cipta milik ANUPARP BUSINESS COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const btns = [
    {
        name: "หน้าแรก",
        path: "/",
    },
    {
        name: "เกี่ยวกับเรา",
        path: "/service",
    },
    {
        name: "บริการ",
        path: "/about",
    },
    {
        name: "ติดต่อเรา",
        path: "/contact",
    },
];
const handleClick = (path) => {
    console.log("path", path);
    router.replace(path);
};
</script>
<style lang="less" scoped>
.footer-content {
    width: 1440px;
    height: 425px;
    background: linear-gradient(90deg, #003B93 0%, #004E84 100%);
    padding: 0 300px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding-top: 53px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        margin-bottom: 59px;

        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 20px;
            margin-bottom: 44px;

            img {
                width: 75px;
                height: 75px;
                object-fit: contain;
                margin-right: 15px;
            }
        }

        .address {
            max-width: 500px;
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 20px;
            text-shadow: 0px 1px 0px #333333;
            margin-bottom: 18px;

            .icon {
                width: 18px;
                height: 18px;
                object-fit: contain;
                margin-right: 8px;
            }

            a {
                color: #FFFFFF;

                &:hover {
                    color: #FFFFFF;
                }

                &:active {
                    color: #FFFFFF;
                }
            }
        }
    }

    .btns {

        .btn {
            font-weight: normal;
            font-size: 14px;
            color: #D9D9D9;
            line-height: 14px;
            cursor: pointer;
            margin-bottom: 30px;
        }
    }

    .bottom {
        font-weight: 500;
        font-size: 15px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>